import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles({
  noDecoration: { textDecoration: 'none' },
  noTransform: { textTransform: 'none' },
});
